import Confirm from '../../modules/Auth/components/Confirm';

function PageConfirm() {
    return <><Confirm/></>
}

export default PageConfirm;
